<template>
  
  <div class="card">
    <div class="card-body" :class="`notify-${message.type}`">
      <div class="row">
        <div class="col-md-12 ml-3">
          <div class="card-title">
            <strong>{{ getTitle }}</strong>
          </div>
          <div class="card-text">
            {{ message.message }}
          </div>
        </div>
      </div>
      <div>
        <span class="close" @click="closeMessage()">x</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    beforeDestroy() {
      if (this.setTimeout) clearInterval(this.setTimeout)
    },
    computed: {
      getTitle() {
        if (this.message.title)
          return this.message.title
        else if (this.message.type === 'success')
          return 'Sucesso'
        else if (this.message.type === 'error')
          return 'Erro'
        else
          return 'Notificação'
      }
    },
    created() {
      const time = this.message.closingTime || 8000
      
      if (time)
        this.setTimeout = setTimeout(() => this.closeMessage(), time)
    },
    methods: {
      closeMessage() {
        this.$emit('closeMessage', this.message)
      }
    },
    name: 'GlobalNotifyMessage',
    props: {
      message: { required: true, type: Object }
    }
  }
</script>

<style scoped>

.card {
  border-radius: 10px;
  box-shadow: 0px 4px 50px rgba(153, 153, 153, 0.25);
  margin-top: 0;
  border: solid 1px #E1E3EB;
}

.card-title{
  margin-bottom: 0;
  padding-right: 24px;
}

.card-body{
  padding: 0rem;
}

.card-text{
  margin-bottom: 5px;
  padding-right: 12px;
  overflow-wrap: break-word;
  word-break: break-word;
}

.notify .close {
  position: absolute;
  right: 8px;
  top: 4px;
  cursor: pointer;
}

.notify-success {
  border-left: 5px solid #15CE9A;
  margin-left: 0.5em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  border-radius: 4px 4px;
}

.notify-error {
  border-left: 5px solid #e93f66;
  margin-left: 0.5em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  border-radius: 4px 4px;
}

</style>